<template>
  <b-container>
    <config-publisher
      ref="configPublisher"
      v-model="config"
      class="p-0"
      tool-name="App Navigation Configuration"
      :config-name="configName"
      :can-edit="canAppNavigationEdit"
      :is-form-valid="isFormValid"
      :can-publish="canAppNavigationPublish">
      <template slot="header">
        <b-col class="pr-0">
          <b-form-radio-group
            v-model="configName"
            class="float-right"
            buttons
            button-variant="outline-primary">
            <b-form-radio value="appnavigationconfig_en">
              EN
            </b-form-radio>
            <b-form-radio value="appnavigationconfig_es">
              ES
            </b-form-radio>
            <b-form-radio value="appnavigationconfig_ja">
              JA
            </b-form-radio>
          </b-form-radio-group>
        </b-col>
      </template>
      <app-navigation-menu
        v-if="config"
        ref="appnavmenu"
        :config="config" />
    </config-publisher>
  </b-container>
</template>

<script>
import {mapGetters} from "vuex"
import AppNavigationMenu from "../components/AppNavigation/AppNavigationMenu"
import ConfigPublisher from "@/components/ConfigPublisher"

export default {
  name: "AppNavigation",
  components: {
    ConfigPublisher,
    AppNavigationMenu,
  },
  data: () => ({
    config: {},
    configName: 'appnavigationconfig_en',
  }),
  computed: {
    ...mapGetters([
      'betaEnvName',
      'liveEnvName',
      'canAppNavigationEdit',
      'canAppNavigationPublish',
    ]),
  },
  methods: {
    isFormValid() {
      const urls = this.config.more.map(section => {
          return section.menus.filter(menu => menu.type !== "application-promo").map(menu => {
            return menu.url
          })
        })

        return !urls.flat().some(url => url === '')
    },
  },
  async beforeRouteLeave(to, from, next) {
    if (this.$refs.configPublisher.configHasChanged()) {
      const message = `You have unpublished changes to your config, which will be lost.\n\nClick "Cancel" to go back and publish your work, or click "Yes" to lose your changes.`
      next(await this.$confirm.open(message))
    } else {
      next()
    }
  },
}
</script>
